import { VoucherActivate, VoucherClaim, VoucherValidate } from '@app/interfaces/_index';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { firstValueFrom } from 'rxjs';
import { ErrorHandlerService } from '../shared/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class VoucherService extends ErrorHandlerService {
  constructor(public http: HttpClient) {
    super();
  }

  /**
   * Post Voucher Claims.
   * @param voucherId - voucherId for the user
   * @returns voucher Claims response
   */
  async claimVoucher(voucherId: string, locale: string): Promise<VoucherClaim> {
    if (!voucherId) {
      return Promise.reject('No Voucher Id provided');
    }

    if (!locale) {
      return Promise.reject('No Locale provided');
    }

    const body = {
      locale: locale,
    };

    return firstValueFrom(
      this.http.post(
        `${environment.voucherApi.url}/vouchers/${voucherId}/claims`,
        JSON.stringify(body)
      )
    )
      .then((response: VoucherClaim) => {
        // NOTE: Use this to test or handle error responses.
        // console.log('response', response);
        // let error = new HttpErrorResponse({status: 403, statusText: 'Permission denied'});
        // throw error;
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  /**
   * Activate the Voucher Claims.
   * @param voucherId - voucherId for the user
   * @param claimId - claimId for the user
   * @param subscriptionGroupName - subscription or user group name
   * @returns the Voucher Activate for a subscription
   */
  async reedemVoucher(
    voucherId: string,
    claimId: string,
    userId: number,
    productId: string,
    language: string
  ): Promise<VoucherActivate> {
    if (!voucherId) {
      return Promise.reject('No Voucher Id provided.');
    }

    if (!claimId) {
      return Promise.reject('No Claim Id provided.');
    }

    if (!userId) {
      return Promise.reject('No User Id provided.');
    }

    if (!productId) {
      return Promise.reject('No Product Id provided.');
    }

    const body = {
      doceboUserId: userId,
      productId: productId,
      locale: language,
    };

    return firstValueFrom(
      this.http.patch(
        `${environment.voucherApi.url}/vouchers/${voucherId}/claims/${claimId}/finalize`,
        JSON.stringify(body)
      )
    )
      .then((response: any) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  /**
   * Get Voucher Claim.
   * @param voucherId - voucherId for the user
   * @returns voucher Claims response
   */
  async getVoucherClaim(voucherId: string): Promise<VoucherValidate[]> {
    if (!voucherId) {
      return Promise.reject('No Voucher Id provided.');
    }

    return firstValueFrom(
      this.http.get(`${environment.voucherApi.url}/vouchers/${voucherId}/claims`)
    )
      .then((response: VoucherValidate[]) => {
        console.log('getVoucherClaim', response);
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
